import React, { useState } from 'react';
import { Row } from "../atoms/StructuralLayout";
import FullScreenDateRangeSelector from "./calendar/FullScreenDateRangeSelector";
import moment, { Moment } from "moment";
import { DateInputField } from "./DateInputField";
import { IconTypes } from "../atoms/icon/Icon";

export function DateRangePicker(props: Props) {
  const {disabled, fromDate, toDate} = props;
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isToDateActive, setIsToDateActive] = useState(false);

  const onDatesSelected = (startDate?: Moment, endDate?: Moment) => {
    if (disabled) return;
    props.onDatesSelected(startDate ?? fromDate, endDate ?? toDate);
  }

  const onDateClick = (dateInputType: string) => {
    if (disabled) return;
    setIsToDateActive(dateInputType === 'toDate');
    setIsCalendarOpen(true);
  }

  return (
    <>
      <Row>
        <DateInputField onClick={() => onDateClick('fromDate')}
                        placeholder="textinput.add-date"
                        disabled={disabled}
                        dataTest={"from-date-field"}
                        style={{width: '100%', margin: 0, marginBottom: 16, marginRight: 16, padding: 0}}
                        value={fromDate ? fromDate.format('D MMMM YYYY') : ''}
                        label={props?.inlineText ? undefined : 'textinput.from'}
                        leftText={props?.inlineText ? 'textinput.from' : undefined}
                        icon={IconTypes.Calendar}
                        editableOnly={true} />

        <DateInputField style={{margin: 0, marginBottom: 16, padding: 0}}
                        onClick={() => onDateClick('toDate')}
                        placeholder="textinput.add-date"
                        dataTest={"to-date-field"}
                        disabled={disabled}
                        icon={IconTypes.Calendar}
                        value={toDate ? toDate.format('D MMMM YYYY') : ''}
                        label={props?.inlineText ? undefined : 'textinput.to'}
                        leftText={props?.inlineText ? 'textinput.to' : undefined}
                        editableOnly={true}/>
      </Row>
      <FullScreenDateRangeSelector open={isCalendarOpen}
                                   onDateSelect={onDatesSelected}
                                   onClose={() => setIsCalendarOpen(false)}
                                   activeToDate={isToDateActive}
                                   startDate={fromDate} endDate={toDate}
                                   initialDate={fromDate ?? moment()} />
    </>
  )
}

interface Props {
  fromDate?: Moment;
  toDate?: Moment;
  disabled: boolean;
  onDatesSelected: (startDate?: Moment, endDate?: Moment) => any;
  inlineText?: boolean;
}
